import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import React from 'react';
import View from "react-native-web/dist/exports/View";
import styleConstructor from "./style";
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Dot = function Dot(_ref) {
  var theme = _ref.theme,
      isMarked = _ref.isMarked,
      isDisabled = _ref.isDisabled,
      dotColor = _ref.dotColor,
      isToday = _ref.isToday,
      isSelected = _ref.isSelected;
  var style = styleConstructor(theme);
  var dotStyle = [style.dot];

  if (isMarked) {
    dotStyle.push(style.visibleDot);

    if (isDisabled) {
      dotStyle.push(style.disabledDot);
    }

    if (isSelected) {
      dotStyle.push(style.selectedDot);
    }

    if (dotColor) {
      dotStyle.push({
        backgroundColor: dotColor
      });
    }

    if (isToday) {
      dotStyle.push(style.todayDot);
    }
  }

  return ___EmotionJSX(View, {
    style: dotStyle
  });
};

export default Dot;

if (typeof Dot !== 'undefined' && Dot && Dot === Object(Dot) && Object.isExtensible(Dot) && !Dot.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Dot, '__filemeta', {
    configurable: true,
    value: {
      name: "Dot",
      filename: "node_modules/react-native-calendars/src/calendar/dot/index.js"
    }
  });
}

Dot.propTypes = {
  theme: PropTypes.object,
  isMarked: PropTypes.bool,
  dotColor: PropTypes.string,
  isSelected: PropTypes.bool,
  isToday: PropTypes.bool,
  isDisabled: PropTypes.bool
};